export default ({ request }) => ({

  getListRecommend (data) {
    return request({
      url: '/digitalCenter/shopCustomerRecommend/list',
      method: 'post',
      data
    })
  },
  detailRecommendApi(data) {
    return request({
      url: '/digitalCenter/shopCustomerRecommend/detail',
      method: 'post',
      data
    })
  },
  detailProductListRecommendApi(data) {
    return request({
      url: '/digitalCenter/shopCustomerRecommend/detailProductList',
      method: 'post',
      data
    })
  },
  saveRecommendApi(data) {
    return request({
      url: '/digitalCenter/shopCustomerRecommend/save',
      method: 'post',
      data
    })
  },
  productSaveRecommendApi(data) {
    return request({
      url: '/digitalCenter/shopCustomerRecommend/productSave',
      method: 'post',
      data
    })
  },
  exportPPTRecommendAPi(data) {
    return request({
      url: '/export/recommend/ppt/export',
      method: 'post',
      data
    })
  },
  downpptAPi(data) {
    return request({
      url: '/young-service/pptExport/exportDown/' + data,
      method: 'get'
    })
  }
})
